import { useEffect, useRef } from "react";
import gsap from "gsap";
import { useSceneStore } from "@/state/useSceneStore";

const IDLE_INTERVAL_MS = 75000;
const MAX_CYCLES = 2;

export const Phone = (): null => {
  const mesh = useSceneStore((s) => s.objects.phone);
  const activeSection = useSceneStore((s) => s.activeSection);
  const cycles = useRef(0);

  useEffect(() => {
    if (!mesh || activeSection !== null) return;
    cycles.current = 0;
    const id = window.setInterval(() => {
      if (cycles.current >= MAX_CYCLES) return;
      if (document.hidden) return;
      cycles.current += 1;
      gsap.to(mesh.rotation, {
        z: 0.06,
        duration: 0.08,
        yoyo: true,
        repeat: 5,
        ease: "power2.out",
        onComplete: () => {
          mesh.rotation.z = 0;
        },
      });
    }, IDLE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [mesh, activeSection]);

  return null;
};
